import { SVG, SVGProps } from './svg'

export function IconTabKey(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M22 6.5v11a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5ZM14.67 13H2.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h12.17l-3.45-3.44a.49.49 0 0 1 0-.7l.71-.71a.5.5 0 0 1 .71 0l5.14 5.13a.77.77 0 0 1 .22.53v.38a.75.75 0 0 1-.22.53l-5.14 5.13a.5.5 0 0 1-.71 0l-.71-.7a.5.5 0 0 1 0-.71L14.67 13Z" />
    </SVG>
  )
}
